
document.addEventListener('DOMContentLoaded', function() {
  // Thumbnail switching
  var mainImg = document.getElementById('ProductMainImage');
  if (mainImg) {
    var thumbs = document.querySelectorAll('.product-thumb');
    thumbs.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var src = this.getAttribute('data-main-src');
        if (src) {
          mainImg.setAttribute('src', src);
        }
      });
    });
  }

  // Scroll reveal
  var revealEls = document.querySelectorAll('.reveal-on-scroll');
  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('reveal-in');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    revealEls.forEach(function(el) {
      observer.observe(el);
    });
  } else {
    // Fallback: show all
    revealEls.forEach(function(el) {
      el.classList.add('reveal-in');
    });
  }
});
